import type {
  ChangeUserRoleRequest,
  ChangeUserRoleResponse,
  DeactivateUserResponse,
  ListUserSessionsResponse,
  ListUsersResponse,
  ReactivateUserResponse,
  RevokeAllSessionsResponse,
} from '@jq4race/shared';

import { request } from './client.js';

export interface ListUsersParams {
  q?: string;
  roles?: string[];
  page?: number;
  limit?: number;
}

export async function listUsers(params?: ListUsersParams): Promise<ListUsersResponse> {
  const qs = new URLSearchParams();
  if (params?.q) qs.set('q', params.q);
  if (params?.roles?.length) {
    for (const r of params.roles) qs.append('role', r);
  }
  if (params?.page !== undefined) qs.set('page', String(params.page));
  if (params?.limit !== undefined) qs.set('limit', String(params.limit));
  const query = qs.toString() ? `?${qs.toString()}` : '';
  return request<ListUsersResponse>(`/admin/users${query}`, { method: 'GET' });
}

export async function changeUserRole(
  userId: string,
  input: ChangeUserRoleRequest,
): Promise<ChangeUserRoleResponse> {
  return request<ChangeUserRoleResponse>(`/admin/users/${encodeURIComponent(userId)}/role`, {
    method: 'PATCH',
    body: input,
  });
}

export async function deactivateUser(userId: string): Promise<DeactivateUserResponse> {
  return request<DeactivateUserResponse>(`/admin/users/${encodeURIComponent(userId)}`, {
    method: 'DELETE',
  });
}

export async function reactivateUser(userId: string): Promise<ReactivateUserResponse> {
  return request<ReactivateUserResponse>(`/admin/users/${encodeURIComponent(userId)}/reactivate`, {
    method: 'POST',
  });
}

export async function listUserSessions(userId: string): Promise<ListUserSessionsResponse> {
  return request<ListUserSessionsResponse>(`/admin/users/${encodeURIComponent(userId)}/sessions`, {
    method: 'GET',
  });
}

export async function revokeUserSession(userId: string, sessionId: string): Promise<void> {
  return request<void>(
    `/admin/users/${encodeURIComponent(userId)}/sessions/${encodeURIComponent(sessionId)}`,
    { method: 'DELETE' },
  );
}

export async function revokeAllUserSessions(userId: string): Promise<RevokeAllSessionsResponse> {
  return request<RevokeAllSessionsResponse>(`/admin/users/${encodeURIComponent(userId)}/sessions`, {
    method: 'DELETE',
  });
}
